import EntitiesList from 'components/entities/EntitiesList';
import { connect } from 'react-redux'
import { getInvoiceConfigurations } from "../../selectors/invoice_configurations";
import InvoiceConfigurationForm from "./InvoiceConfigurationForm";
import InvoiceConfigurationsListItem from "./InvoiceConfigurationsListItem";

const mapStateToProps = (state, ownProps) => {
  return {
    entities: getInvoiceConfigurations(state),
    entityName: 'invoiceConfiguration',
    item: InvoiceConfigurationsListItem,
    form: InvoiceConfigurationForm,
    loading: state.meta?.invoiceConfiguration?.loading,
    error: state.meta?.invoiceConfiguration?.error
  };
}

export default connect(mapStateToProps)(EntitiesList)
